export default "__VITE_ASSET__S78ZWtpM__"